"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaceTypeSchema = void 0;
const zod_1 = require("zod");
exports.FaceTypeSchema = zod_1.z.enum(['F', 'B']);
//# sourceMappingURL=FaceType.js.map